<template>
  <v-card class="deviation">
    <div class="deviation-action-box">
      <div class="d-flex justify-space-between align-self-stretch">
        <div class="deviation-name">{{ deviation.task.name }}</div>
        <div
          class="deviation-show-button"
          @click="goToDeviation"
        ><v-icon :class="highlightId === deviation.id ? 'deviation-show-button-highlighted' : ''"
        >mdi-eye</v-icon></div>
      </div>
      <div class="deviation-time">
        {{ format(fromUnixTime(deviation.click ? deviation.click.timestamp : deviation.timestamp),
        'HH:mm EEEE', { locale: getLanguagePackFromBrowser() }) }}
      </div>
      <div class="deviation-date">
        {{ format(fromUnixTime(deviation.click ? deviation.click.timestamp : deviation.timestamp),
        'do LLL yyyy', { locale: getLanguagePackFromBrowser() }) }}
      </div>

      <v-btn
        :class="confirm ? 'deviation-action-button-pending' : 'deviation-action-button'"
        color="#232C49"
        :disabled="loading"
        @click="approveDeviation(deviation.id)"
      >{{ confirm ? $t('Confirm') : $t('Approve') }}</v-btn>
    </div>
  </v-card>
</template>

<script>
import { format, fromUnixTime } from 'date-fns';
import { getLanguagePackFromBrowser } from '../../globals/helpers/language';

export default {
  props: {
    deviation: {
      type: Object,
      required: true,
      default: () => {},
    },
    highlightId: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      confirm: false,
    };
  },
  beforeDestroy() {
    this.$emit('resetHighlight');
  },
  methods: {
    format,
    fromUnixTime,
    getLanguagePackFromBrowser,
    goToDeviation() {
      if (this.highlightId === this.deviation.id) {
        this.$emit('resetHighlight');
      } else {
        this.$emit('goToDeviation', this.deviation.id);
      }
    },
    approveDeviation(id) {
      this.$emit('approve', id);
    },
  },
};
</script>

<style scoped lang="scss">
  .deviation {
    display: flex;
    padding: 6px;
    align-items: center;
    min-width: 200px;
    height: 128px;
  }

  .deviation-name {
    font-size: 14px;
    font-weight: 600;
    align-self: start;
  }

  .deviation-time {
    align-self: start;
    font-size: 13px;
  }

  .deviation-date {
    align-self: start;
    font-size: 13px;
    margin-bottom: 6px;
  }

  .deviation-action-box {
    align-self: stretch;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    text-align: center;
  }

  .deviation-action-button, .deviation-action-button-pending {
    color: #fff;
  }

  .deviation-action-button-pending {
    background-color: $primary !important;
  }

  .deviation-show-button {
    padding: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    transition: all 0.2s;
    cursor: pointer;

    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
    }
  }

  .deviation-show-button-highlighted {
    color: $primary;
  }
</style>
